import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useThemeWithUndefined } from '@rescui/ui-contexts';
import styles from '../index.p.module.css.js';
import { useMenuContext } from './menu-context.js';
const SIZE_CLASS = {
  s: styles.groupHeaderSizeS,
  m: styles.groupHeaderSizeM,
  l: styles.groupHeaderSizeL
};
const THEME_CLASS = {
  light: styles.groupHeaderThemeLight,
  dark: styles.groupHeaderThemeDark
};

function GroupHeader(_ref) {
  let {
    className = null,
    text,
    size: propsSize = 'm',
    theme: propsTheme
  } = _ref;
  const menuContext = useMenuContext();
  const Tag = menuContext.wrapWithLi ? 'li' : 'span';
  const actualTheme = useThemeWithUndefined(menuContext.theme ?? propsTheme);
  return /*#__PURE__*/React.createElement(Tag, {
    className: cn(styles.groupHeader, SIZE_CLASS[menuContext.size ?? propsSize], THEME_CLASS[actualTheme], className),
    "data-rs-internal": 'menu__group-header'
  }, text);
}

GroupHeader.propTypes = {
  size: PropTypes.oneOf(['m', 's']),
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  text: PropTypes.string
};
export { GroupHeader as default };
